import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import getV3StockMtHistorytradefilter from '@services/api/stock/history/margin';

function useHistoryMt() {
  const { cb, key } = getV3StockMtHistorytradefilter();

  const {
    data,
    isInitialLoading,
    refetch,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(key, cb, {
    getNextPageParam: (lastPage, allPages) => lastPage?.result?.next && allPages.length + 1,
    select: (_data) => _data.pages?.flatMap((page) => page?.result.results || []),
  });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    refetch,
    isRefetching,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default useHistoryMt;
